import { Component, ContentChild, EventEmitter, Input, OnDestroy, OnInit, Output, TemplateRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';

import { ModalService } from '../../services/modal.service';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
})
export class ModalComponent implements OnInit, OnDestroy {
  @Input() name: string;
  @Input() title?: string;
  @Input() size?: 'sm' | 'lg' | 'xl';

  @Output() hide: EventEmitter<void> = new EventEmitter<void>();

  @ContentChild('header', { read: TemplateRef }) header?: TemplateRef<any>;
  @ContentChild('footer', { read: TemplateRef }) footer?: TemplateRef<any>;

  get modalSizeClass(): string {
    return this.size ? `modal-${this.size}` : '';
  }

  get isActive(): boolean {
    return this.activeModal === this.name;
  }

  get hasHeader(): boolean {
    return !!this.header;
  }

  get hasFooter(): boolean {
    return !!this.footer;
  }

  private subscription: Subscription;
  private activeModal: string;

  constructor(private service: ModalService) {}

  ngOnInit(): void {
    this.subscription = this.service.modal
      .pipe(
        tap(id => this.activeModal = id)
      )
      .subscribe();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  closeModal() {
    this.service.hide(this.name);
    this.hide.emit();
  }
}
